module.exports = __webpack_public_path__ + "img/Group 97841.a333e7cf.png";